<div
  class="player-error-container horizontal-center horizontal-focusable-container back-btn"
  (keydown)="handleKeydown($event)"
  (click)="disabled($event)"
  (mouseenter)="disabled($event)"
  (mouseleave)="disabled($event)"
>
  <div class="player-error-modal">
    <h2>{{ error?.service }}</h2>
    <p>{{ getLocalizedMessage() }}</p>
    <div class="error-code">{{ getErrorCode() }}</div>
    <app-icon-button
      [label]="getButtonLabel() | translate"
      (clicked)="goBack()"
    ></app-icon-button>
  </div>
</div>
